//
// IMPORTS
//

import { combineReducers } from 'redux'
import { createResponsiveStateReducer } from 'redux-responsive'

import location from './location'
import menu from './menu'
import modal from './modal'
import wpData from './wpData'
import tracking from './tracking'

//
// REDUCER
//

const rootReducer = combineReducers({
  location,
  menu,
  modal,
  wpData,
  tracking,
  browser: createResponsiveStateReducer({
    // corresponds to our Sass breakpoint variables
    mini: 480, // 30em
    sm: 640, // 40em
    md: 832, // 52em
    lg: 1024, // 64em
    xl: 1280,
    xxl: 1500
  })
})

//
// EXPORT
//

export default rootReducer



// WEBPACK FOOTER //
// ./frontend/scripts/reducers/index.js